import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface BackdropProps {
  show: boolean;
  className?: string;
  onClick?: () => void;
}

const Backdrop = ({ show, className, onClick }: BackdropProps) => {
  return (
    show && (
      <div
        className={classNames(styles.backdrop, className)}
        onClick={onClick}
        data-test-id="backdrop"
      />
    )
  );
};

export default Backdrop;
